export interface ITheme {
  id: string
  name: string
}

export const availableThemes: ITheme[] = [
  { id: 'light-theme', name: 'Light' },
  { id: 'dark-theme', name: 'Dark' },
]
